class SubscriptionRequest {
  static create = {
    subscriptionCustomerId: null,
    subscriptionProfessionalId: null,
    subscriptionDays: null,
    subscriptionType: null,
    subscriptionTopic: null,
    subscriptionMessage: null,
    subscriptionAmount: null,
    subscriptionStartTime: null,
    subscriptionEndTime: null,
    subscriptionStatus: null
  };

  static approve = {
    subscriptionId: null
  };

  static decline = {
    subscriptionId: null
  };

  static readByProfessionalId = {
    subscriptionProfessionalId: null
  };

  static readByCustomerId = {
    subscriptionCustomerId: null
  };

  static update = {
    subscriptionPlanProfessionalId: null,
    weeklySubscriptionAmount: null,
    monthlySubscriptionAmount: null
  };
}

export default SubscriptionRequest;
